module.exports = __webpack_public_path__ + "img/31.a0e871f0.png";